import { gql } from '@apollo/client';

export const ALL_DUPLICATE_INSTITUTIONS = gql`
  query AllDuplicateInstitutions($input: FilterInstitutions!) {
    institutions: getDuplicateInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          isArchived
          #relationship
          district {
            id
            name
          }
          duplicateAction
          duplicateReference
          wardID
          wardLabel

          name
          localMunicipality {
            id
            localMunicipalityShorthand
          }
          districtMunicipality {
            id
            name
          }
          reasonForDuplicateAction
          type {
            id
            name
          }
          status
        }
      }
    }
  }
`;
